import {useCallback, useEffect, useRef} from 'react';

export function useIsMounted() {
    const componentIsMounted = useRef(true);

    useEffect(() => {
        return () => {
            componentIsMounted.current = false;
        };
    }, []);

    return useCallback(() => componentIsMounted.current, []);
}
